<template>
  <div v-if="show" class="modal-overlay">
    <div class="modal-content">
      <img 
        :src="imageUrl" 
        class="success-image"
      />
      <p v-html="message"></p>
      <button @click="closeModal">OK</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    message: String,
    imageUrl: {
      type: String,
      default: "/images/logo_clc_potrait.jpg",
    },
  },
  methods: {
    closeModal() {
        this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content {
  background: white;
  padding: 20px;
  padding-top: 15px;
  text-align: center;
  border-radius: 8px;
  width: 358px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
button {
  width: 70px;
  background: #4caf50;
  color: white;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  margin-top: 10px;
}
.success-image{
    width: 43%;
}
</style>
